module.exports = __webpack_public_path__ + "img/jcb-green.b206005e.svg";